import fetch from 'isomorphic-fetch';
import { consentApiUrl } from '../client/environment';
import { ConsentResponse } from '../client/appTypings';
import { ConsentError } from '../client/error/errors';

const version = 'v2';
const jsonDataPath = `app-jsons/v2/areena-bigscreen.${version}.json`;

export const fetchConsentData = async () => {
  try {
    const response = await fetch(`${consentApiUrl}${jsonDataPath}`);
    const json = (await response.json()) as ConsentResponse;
    return json;
  } catch (e) {
    throw new ConsentError(`Failed to load consent json data:${e}`);
  }
};
